var _path, _path2, _path3, _path4, _path5, _path6, _rect, _circle, _path7, _path8, _path9, _path10, _rect2, _path11, _rect3, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 968,
    height: 984,
    viewBox: "0 0 968 984",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M923.956 49.8652H88.0441C63.7193 49.8652 44 74.8589 44 105.69V928.175C44 959.007 63.7193 984 88.0441 984H923.956C948.281 984 968 959.007 968 928.175V105.69C968 74.8589 948.281 49.8652 923.956 49.8652Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M880.908 0H44.0916C19.7405 0 0 24.9937 0 55.825V878.31C0 909.141 19.7405 934.135 44.0916 934.135H880.908C905.26 934.135 925 909.141 925 878.31V55.825C925 24.9937 905.26 0 880.908 0Z",
    fill: "#565A65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0775 0H880.736C892.427 0 903.64 3.86034 911.907 10.7318C920.174 17.6032 924.819 26.9229 924.819 36.6406V91.51H0V36.6406C-9.11502e-08 26.9237 4.64363 17.6046 12.9096 10.7333C21.1756 3.86201 32.3869 0.0012134 44.0775 0Z",
    fill: "#EAEEEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M80.0127 60.4324C89.7689 60.4324 97.6778 53.8616 97.6778 45.7562C97.6778 37.6508 89.7689 31.0801 80.0127 31.0801C70.2566 31.0801 62.3477 37.6508 62.3477 45.7562C62.3477 53.8616 70.2566 60.4324 80.0127 60.4324Z",
    fill: "#283035"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M134.047 60.4324C143.803 60.4324 151.712 53.8616 151.712 45.7562C151.712 37.6508 143.803 31.0801 134.047 31.0801C124.291 31.0801 116.382 37.6508 116.382 45.7562C116.382 53.8616 124.291 60.4324 134.047 60.4324Z",
    fill: "#283035"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M184.964 60.4324C194.146 60.4324 201.59 53.8616 201.59 45.7562C201.59 37.6508 194.146 31.0801 184.964 31.0801C175.782 31.0801 168.338 37.6508 168.338 45.7562C168.338 53.8616 175.782 60.4324 184.964 60.4324Z",
    fill: "#283035"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 104,
    width: 901,
    height: 236,
    fill: "#C4C4C4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 340,
    r: 71,
    fill: "#C4C4C4",
    stroke: "#565A65",
    strokeWidth: 8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63 447H213",
    stroke: "#C4C4C4",
    strokeWidth: 25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59 578H459",
    stroke: "#C4C4C4",
    strokeWidth: 17,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59 549H459",
    stroke: "#C4C4C4",
    strokeWidth: 17,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59 609H459",
    stroke: "#C4C4C4",
    strokeWidth: 17,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 675,
    width: 819,
    height: 67,
    rx: 5,
    fill: "#C4C4C4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M387 708H537",
    stroke: "#565A65",
    strokeWidth: 17,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 766,
    width: 819,
    height: 67,
    rx: 5,
    fill: "#C4C4C4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M387 799H537",
    stroke: "#565A65",
    strokeWidth: 17,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.74abfbf5276b9c783eb3c1d1dfa73105.svg";
export { ForwardRef as ReactComponent };